export const SELECT_DOMAIN_FOR_CERTIFICATION =
  "SELECTED_DOMAIN_FOR_CERTIFICATION";
export const CURRENT_DOMAIN_FOR_CERTIFICATION =
  "CURRENT_DOMAIN_FOR_CERTIFICATION";
export const SELECT_COURSE_FOR_CERTIFICATION =
  "SELECTED_COURSE_FOR_CERTIFICATION";
export const CURRENT_CERTIFICATION_ID = "CURRENT_CERTIFICATION_ID";
export const SELECT_ACTIVE_SERVICE_DOMAIN = "SELECT_ACTIVE_SERVICE_DOMAIN";
export const DELETE_SERVICE_DOMAIN = "DELETE_SERVICE_DOMAIN";
export const CLEAR_ALL_SERVICE_DOMAIN = "CLEAR_ALL_SERVICE_DOMAIN";
export const REQUEST_SERVICE_DOMAIN = "REQUEST_SERVICE_DOMAIN";
export const GET_RESPONSE_SERVICE_DOMAIN = "GET_RESPONSE_SERVICE_DOMAIN";
export const ERROR_GET_RESPONSE = "ERROR_GET_REPONSE";
export const RESPONsE_SERVICE_DOMAIN = "RESPONSE_SERVICE_DOMAIN";
export const CLEAR_RESPONSE = "CLEAR_RESPONSE";
export const SERVICE_DOMAIN_TAB = "SERVICE_DOMAIN_TAB";
export const SERVICE_DOMAIN_TAB_RESET = "SERVICE_DOMAIN_TAB_RESET";
